import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import DonationQuickAction from '../../components/ui/DonationQuickAction';
import FilterPanel from './components/FilterPanel';
import SortControls from './components/SortControls';
import QuickFilters from './components/QuickFilters';
import CharityGrid from './components/CharityGrid';

const CauseDiscovery = () => {
  const [filters, setFilters] = useState({
    search: '',
    categories: [],
    locations: [],
    impactSizes: [],
    trustLevels: [],
    quickFilters: []
  });
  
  const [sortBy, setSortBy] = useState('relevance');
  const [viewMode, setViewMode] = useState('grid');
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [charities, setCharities] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  // Mock charity data
  const mockCharities = [
    {
      id: 1,
      name: "Clean Water Initiative",
      category: "Environment",
      location: "Global",
      mission: "Providing clean, safe drinking water to communities in need across developing nations through sustainable infrastructure projects and community education programs.",
      logo: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=100&h=100&fit=crop&crop=center",
      headerImage: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400&h=200&fit=crop",
      isVerified: true,
      transparencyScore: 95,
      efficiencyRating: 4.8,
      totalRaised: 2450000,
      peopleHelped: 125000,
      isBookmarked: false
    },
    {
      id: 2,
      name: "Education for All Foundation",
      category: "Education",
      location: "National",
      mission: "Ensuring every child has access to quality education regardless of their socioeconomic background through scholarships, school supplies, and teacher training programs.",
      logo: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=100&h=100&fit=crop&crop=center",
      headerImage: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=400&h=200&fit=crop",
      isVerified: true,
      transparencyScore: 92,
      efficiencyRating: 4.6,
      totalRaised: 1890000,
      peopleHelped: 45000,
      isBookmarked: true
    },
    {
      id: 3,
      name: "Medical Relief Corps",
      category: "Health & Medical",
      location: "International",
      mission: "Delivering emergency medical care and establishing healthcare infrastructure in underserved communities worldwide, focusing on preventive care and medical education.",
      logo: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=100&h=100&fit=crop&crop=center",
      headerImage: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=200&fit=crop",
      isVerified: true,
      transparencyScore: 88,
      efficiencyRating: 4.7,
      totalRaised: 3200000,
      peopleHelped: 89000,
      isBookmarked: false
    },
    {
      id: 4,
      name: "Food Security Network",
      category: "Poverty & Hunger",
      location: "Local",
      mission: "Combating food insecurity through community gardens, food banks, and nutrition education programs that empower families to achieve long-term food stability.",
      logo: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=100&h=100&fit=crop&crop=center",
      headerImage: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=400&h=200&fit=crop",
      isVerified: false,
      transparencyScore: 85,
      efficiencyRating: 4.4,
      totalRaised: 567000,
      peopleHelped: 12000,
      isBookmarked: false
    },
    {
      id: 5,
      name: "Wildlife Conservation Alliance",
      category: "Animal Welfare",
      location: "International",
      mission: "Protecting endangered species and their habitats through research, conservation efforts, and community-based wildlife protection programs across multiple continents.",
      logo: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=100&h=100&fit=crop&crop=center",
      headerImage: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&h=200&fit=crop",
      isVerified: true,
      transparencyScore: 91,
      efficiencyRating: 4.5,
      totalRaised: 1450000,
      peopleHelped: 0,
      isBookmarked: true
    },
    {
      id: 6,
      name: "Disaster Response Team",
      category: "Disaster Relief",
      location: "National",
      mission: "Providing rapid emergency response and long-term recovery support to communities affected by natural disasters, including shelter, food, and rebuilding assistance.",
      logo: "https://images.unsplash.com/photo-1586771107445-d3ca888129ff?w=100&h=100&fit=crop&crop=center",
      headerImage: "https://images.unsplash.com/photo-1586771107445-d3ca888129ff?w=400&h=200&fit=crop",
      isVerified: true,
      transparencyScore: 94,
      efficiencyRating: 4.9,
      totalRaised: 2100000,
      peopleHelped: 67000,
      isBookmarked: false
    },
    {
      id: 7,
      name: "Human Rights Advocacy",
      category: "Human Rights",
      location: "Global",
      mission: "Defending human rights and promoting social justice through legal advocacy, awareness campaigns, and support for marginalized communities worldwide.",
      logo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop&crop=center",
      headerImage: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=200&fit=crop",
      isVerified: true,
      transparencyScore: 89,
      efficiencyRating: 4.3,
      totalRaised: 890000,
      peopleHelped: 23000,
      isBookmarked: false
    },
    {
      id: 8,
      name: "Arts & Culture Preservation",
      category: "Arts & Culture",
      location: "Local",
      mission: "Preserving cultural heritage and promoting arts education through community programs, museum exhibitions, and support for local artists and cultural institutions.",
      logo: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=100&h=100&fit=crop&crop=center",
      headerImage: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=400&h=200&fit=crop",
      isVerified: false,
      transparencyScore: 82,
      efficiencyRating: 4.1,
      totalRaised: 234000,
      peopleHelped: 5600,
      isBookmarked: true
    },
    {
      id: 9,
      name: "Mental Health Support Network",
      category: "Health & Medical",
      location: "National",
      mission: "Providing accessible mental health services, crisis intervention, and community support programs to reduce stigma and improve mental wellness for all.",
      logo: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=100&h=100&fit=crop&crop=center",
      headerImage: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=200&fit=crop",
      isVerified: true,
      transparencyScore: 93,
      efficiencyRating: 4.6,
      totalRaised: 1670000,
      peopleHelped: 34000,
      isBookmarked: false
    }
  ];

  useEffect(() => {
    loadCharities();
  }, [filters, sortBy]);

  const loadCharities = async () => {
    setLoading(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 800));
    
    let filteredCharities = [...mockCharities];
    
    // Apply filters
    if (filters?.search) {
      filteredCharities = filteredCharities?.filter(charity =>
        charity?.name?.toLowerCase()?.includes(filters?.search?.toLowerCase()) ||
        charity?.mission?.toLowerCase()?.includes(filters?.search?.toLowerCase()) ||
        charity?.category?.toLowerCase()?.includes(filters?.search?.toLowerCase())
      );
    }
    
    if (filters?.categories?.length > 0) {
      filteredCharities = filteredCharities?.filter(charity =>
        filters?.categories?.some(cat => charity?.category?.toLowerCase()?.includes(cat))
      );
    }
    
    if (filters?.locations?.length > 0) {
      filteredCharities = filteredCharities?.filter(charity =>
        filters?.locations?.some(loc => charity?.location?.toLowerCase()?.includes(loc))
      );
    }
    
    if (filters?.trustLevels?.includes('verified')) {
      filteredCharities = filteredCharities?.filter(charity => charity?.isVerified);
    }
    
    if (filters?.trustLevels?.includes('transparent')) {
      filteredCharities = filteredCharities?.filter(charity => charity?.transparencyScore >= 90);
    }
    
    if (filters?.trustLevels?.includes('efficient')) {
      filteredCharities = filteredCharities?.filter(charity => charity?.efficiencyRating >= 4.5);
    }
    
    // Apply quick filters
    if (filters?.quickFilters?.includes('verified')) {
      filteredCharities = filteredCharities?.filter(charity => charity?.isVerified);
    }
    
    if (filters?.quickFilters?.includes('local')) {
      filteredCharities = filteredCharities?.filter(charity => charity?.location === 'Local');
    }
    
    if (filters?.quickFilters?.includes('high-impact')) {
      filteredCharities = filteredCharities?.filter(charity => charity?.peopleHelped > 50000);
    }
    
    // Apply sorting
    switch (sortBy) {
      case 'impact':
        filteredCharities?.sort((a, b) => b?.peopleHelped - a?.peopleHelped);
        break;
      case 'transparency':
        filteredCharities?.sort((a, b) => b?.transparencyScore - a?.transparencyScore);
        break;
      case 'efficiency':
        filteredCharities?.sort((a, b) => b?.efficiencyRating - a?.efficiencyRating);
        break;
      case 'alphabetical':
        filteredCharities?.sort((a, b) => a?.name?.localeCompare(b?.name));
        break;
      case 'newest':
        filteredCharities?.reverse();
        break;
      default: // relevance
        break;
    }
    
    setCharities(filteredCharities);
    setPage(1);
    setHasMore(filteredCharities?.length > 9);
    setLoading(false);
  };

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleQuickFilter = (filterId) => {
    const newFilters = { ...filters };
    if (!newFilters?.quickFilters) newFilters.quickFilters = [];
    
    if (newFilters?.quickFilters?.includes(filterId)) {
      newFilters.quickFilters = newFilters?.quickFilters?.filter(id => id !== filterId);
    } else {
      newFilters.quickFilters = [...newFilters?.quickFilters, filterId];
    }
    
    setFilters(newFilters);
  };

  const handleClearAllFilters = () => {
    setFilters({
      search: '',
      categories: [],
      locations: [],
      impactSizes: [],
      trustLevels: [],
      quickFilters: []
    });
  };

  const handleLoadMore = () => {
    setPage(prev => prev + 1);
    // In a real app, this would load more data
    setHasMore(false);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">Discover Causes</h1>
          <p className="text-lg text-muted-foreground">
            Find verified charitable organizations making a real impact in causes you care about
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Filter Sidebar */}
          <div className="lg:w-80 flex-shrink-0">
            <FilterPanel
              filters={filters}
              onFiltersChange={handleFiltersChange}
              isOpen={isFilterPanelOpen}
              onToggle={() => setIsFilterPanelOpen(!isFilterPanelOpen)}
              resultCount={charities?.length}
            />
          </div>

          {/* Main Content */}
          <div className="flex-1">
            {/* Quick Filters */}
            <QuickFilters
              activeFilters={filters}
              onQuickFilter={handleQuickFilter}
              onClearAll={handleClearAllFilters}
            />

            {/* Sort Controls */}
            <SortControls
              sortBy={sortBy}
              onSortChange={setSortBy}
              viewMode={viewMode}
              onViewModeChange={setViewMode}
            />

            {/* Results */}
            <CharityGrid
              charities={charities}
              loading={loading}
              viewMode={viewMode}
              onLoadMore={handleLoadMore}
              hasMore={hasMore}
            />
          </div>
        </div>
      </div>
      <DonationQuickAction />
    </div>
  );
};

export default CauseDiscovery;